<script lang="ts" setup>
import { ref, onMounted, onBeforeUnmount, computed } from 'vue'
import { Vue3Lottie } from 'vue3-lottie'
import { AnswerResultType } from '../../types/assessment'
import iconSad from '../../assets/animations/icon_sad.json'
import iconClaps from '../../assets/animations/icon_claps.json'

interface AnimationItem {
    id: number
    left: number
    duration: number
    size: number
    createdAt: number
}

const { type } = defineProps<{
    type: AnswerResultType
}>()

const animationData = computed(() => {
    if (type === AnswerResultType.CORRECT) {
        return iconClaps
    }
    return iconSad
})

const animations = ref<AnimationItem[]>([])
let idCounter = 0
let intervalId: number

onMounted(() => {
    intervalId = window.setInterval(() => {
        const duration = 1.5 + Math.random() * 1.2 //random 1.5s–2.7s
        const newItem: AnimationItem = {
            id: idCounter++,
            left: Math.random() * 90,
            duration,
            size: 40 + Math.random() * 40,
            createdAt: Date.now()
        }
        animations.value.push(newItem)
        setTimeout(() => {
            animations.value = animations.value.filter(item => item.id !== newItem.id)
        }, duration * 1000)
    }, 250)
})

onBeforeUnmount(() => {
    clearInterval(intervalId)
})

const getStyle = (item: AnimationItem) => {
    return {
        left: `${item.left}%`,
        width: `${item.size}px`,
    }
}
</script>

<template>
    <div class="relative w-full h-screen overflow-hidden">
        <div v-for="item in animations" class="absolute bottom-0 animate-floatUp" :style="getStyle(item)"
            :key="item.id">
            <Vue3Lottie :animation-data="animationData" :loop="true" :autoplay="true" />
        </div>
    </div>
</template>